<template>
    <v-dialog
      persistent
      v-model="dialogFlag"
      :fullscreen="fullscreen"
      :width="fullscreen ? null: width"
    >
        <v-card>
            <v-toolbar dense elevation="0" dark :color="color">
              <v-toolbar-title> {{ title }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="closeDialog">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <slot>
              <v-card-text></v-card-text>
            </slot>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
  name: 'WowKitDialog',
  model: {
    prop: 'value'
  },
  props: {
    title: {
      type: String,
      default: 'Dialog Title'
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: null
    },
    persistent: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'accent'
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dialogFlag = newVal
      }
    }
  },
  data () {
    return {
      dialogFlag: this.value ? this.value : false
    }
  },
  methods: {
    closeDialog: function () {
      this.dialogFlag = false
      this.$emit('close', this.dialogFlag)
    }
  }
}
</script>
